import state from './moduleEnterpriseVesselListState.js'
import mutations from './moduleEnterpriseVesselListMutations.js'
import actions from './moduleEnterpriseVesselListActions.js'
import getters from './moduleEnterpriseVesselListGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
